import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Country } from 'src/app/models/country';
import { AlertDialog } from 'src/app/util/alert-dialog/alert-dialog';
import { ContactService } from '../contact/contact.service';

/**
 * The "request access" and "request this country" dialogs, shared by the pages that
 * show a country the user cannot open (the country page and the payroll calculator).
 */
@Injectable({
  providedIn: 'root',
})
export class CountryRequestService {
  constructor(
    private dialog: MatDialog,
    private contactService: ContactService,
    private snackBar: MatSnackBar
  ) {}

  public requestAddToSubscription(country: Country): void {
    if (country.unsupported) {
      return this.requestCreateCountry(country);
    }
    this.confirmAndSend(
      {
        title: 'Request access',
        message: ''.concat(
          'This country is not part of your current subscription. To request access to the country profile for ',
          country.name,
          ', click the "Submit request" button below.'
        ),
      },
      'Request Country from Country Detail Page',
      country,
      ''.concat('Your request to add ', country.name, '  has been submitted')
    );
  }

  public requestCreateCountry(country: Country): void {
    this.confirmAndSend(
      {
        title: 'Request country',
        message:
          'This country is currently unavailable. To request access, click the "Submit request" button below.',
      },
      'Request Unavailable Country from Country Detail Page',
      country,
      ''.concat('Your request to access ', country.name, '  has been submitted')
    );
  }

  private confirmAndSend(
    text: { title: string; message: string },
    type: string,
    country: Country,
    sentMessage: string
  ): void {
    const dialogRef = this.dialog.open(AlertDialog, {
      width: '600px',
      data: {
        ...text,
        cancelButtonText: 'Cancel',
        okButtonText: 'Submit request',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.contactService
          .postComment({ type, data: { country: country.name } })
          .subscribe(
            () => {
              this.snackBar.open(sentMessage, 'Close', { duration: 5000 });
            },
            () => {
              this.snackBar.open(
                'There was a problem sending the message. Please contact support@globalpeoplestrategist.com for assistance',
                'Close'
              );
            }
          );
      }
    });
  }
}
